const state = {
    currentTime: '',
}
const mutations = {
    setCurrentTime(state, model) {
        state.currentTime = model
    },
}
const actions = {

}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};